import React, { Component } from 'react'
import { withRouter } from 'react-router'
import Modal from 'react-modal'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import OnboardingEventConfigDetailPageUI from './OnboardingEventConfigDetailPageUI'

class OnboardingEventConfigDetailPageSF extends Component {
    constructor(props) {
        super(props)
        this.state = {
            eventDetails: null,
            loading: true,
            errorList: null
        }
    }

    componentDidMount() {
        this.getEventDetails()
        Modal.setAppElement('body')
    }

    getEventDetails = () => {
        let context = this.props.context
        let eventCode = this.props.match.params.eventCode

        if (eventCode) {
            RestApiUtils.get(context, `/api/notify-event-configurations/${eventCode}`, this.getEventDetailsCallback)
        } else {
            this.setState({ loading: false, errorList: [{ message: 'Invalid Event Code' }] })
        }
    }

    getEventDetailsCallback = (response) => {
        console.log(response)
        console.log("!response.errorList", !response.errorList)
        if (response && !response.errorList.length) {
            this.setState({ eventDetails: response.entity, loading: false })
        } else if (response.errorList) {
            this.setState({ errorList: response.errorList, loading: false })
        } else {
            // Handle unexpected response
            this.setState({ loading: false, errorList: [{ message: 'Failed to load details' }] })
        }
    }

    onClose = () => {
        this.props.history.push('/su/onboarding-events');
    }

    render() {
        return (
            <OnboardingEventConfigDetailPageUI
                context={this.props.context}
                eventDetails={this.state.eventDetails}
                loading={this.state.loading}
                errorList={this.state.errorList}
                onClose={this.onClose}
            />
        )
    }
}

export default withRouter(OnboardingEventConfigDetailPageSF)
